import axios from "axios";
import CryptoJS from "crypto-js";

const SECRET_KEY = "1234567890abcdef1234567890abcdef";

// 🔐 Encrypt
const encryptPayload = (data) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();
};

/* ================= DECRYPT ================= */
const decryptFunction = (ciphertext) => {

  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (e) {
    console.error("Decryption failed:", e);
    return ciphertext;
  }
};

const CallReview_API = process.env.REACT_APP_CALL_REVIEW ;

// 📡 GET Call Review
export const getCallReview = async (callId) => {
  const BASE_URL = CallReview_API;

  try {
    if (!callId) {
      throw new Error("CallId is missing");
    }

  

    const url = `${BASE_URL}&callid=${callId}`;

    // console.log("🚀 API URL:", url);

    const response = await axios.get(url);

    if (!response || !response.data) {
      throw new Error("Empty response from server");
    }

    // console.log("📦 Raw Response:", response.data);

    // 🔓 decrypt safely
    try {
      return decryptFunction(response.data);
      
    } catch (e) {
      console.warn("⚠️ Response not encrypted, returning raw");
      return response.data;
    }

  } catch (error) {
    console.error("❌ API Error:", error);

    // Axios specific error handling
    if (error.response) {
      const err = new Error(error.response.data?.message || "Server Error");
      err.status = error.response.status;
      throw err;
    } else if (error.request) {
      throw new Error("No response from server");
    } else {
      throw new Error(error.message || "Something went wrong");
    }
  }
};